<template>
  <div class="expertsList">
    <!-- 参会专家 -->
    <div :class="{bgcfff :showInputNum}" class="experts_base">
      <div class="experts_tiele">

        <div class="experts_search">
          <span v-if="!showInputNum" class="experts_input_no"><a-icon type="search" /> 搜索专家姓名</span>

          <div :class="{experts_input_show :showInputNum}" class="experts_input_box">
            <a-icon class="experts_icon icon_left" type="search" />
            <input @keydown="showInput(1)" v-model="name" type="text" name="" id="">
            <a-icon @click="clearInput()" class="experts_icon icon_right" type="close-circle" />
            <span @click="showInput(0)" v-if="showInputNum" class="experts_input_close">取消</span>
          </div>

        </div>

        <div v-if="!showInputNum" class="experts_menu">
          <div @click="experts_menu_Fn('讲者')" :class="{experts_menu_check :experts_menu_num=='讲者'}"
            class="experts_menu_item">讲者
            <span v-show="experts_menu_num=='讲者'" class="experts_menu_Line"></span>
          </div>
          <div @click="experts_menu_Fn('主席及点评')" :class="{experts_menu_check :experts_menu_num=='主席及点评'}"
            class="experts_menu_item">主席及点评
            <span v-show="experts_menu_num=='主席及点评'" class="experts_menu_Line"></span>
          </div>
          <div @click="experts_menu_Fn('主席团')" :class="{experts_menu_check :experts_menu_num=='主席团'}"
            class="experts_menu_item">主席团
            <span v-show="experts_menu_num=='主席团'" class="experts_menu_Line"></span>
          </div>
        </div>

      </div>

    </div>

    <!-- 参会专家_列表 -->
    <div :class="{hidden :showInputNum}" class="experts_list">
      <div v-for="(value, key, index)  in all" :key="index" class="experts_list_item">
        <div class="experts_item_title">{{key}}</div>
        <div v-for="item in value" :key="item.id" class="experts_item_data">
          <div class="experts_item_img">
            <img width="30px" :src="item.avatar" alt="">
          </div>
          <div class="experts_item_desc">
            <div class="experts_item_name">{{item.doctor_name}}</div>
            <div class="experts_item_hos">{{item.hospital_title}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 参会专家_搜索 -->
    <div v-if="showInputNum" class="experts_search_base">
      <div v-for="(value, key, index)  in all" :key="index" class="experts_list_item">
        <div class="experts_item_title">{{key}}</div>
        <div v-for="item in value" :key="item.id" class="experts_item_data">
          <div class="experts_item_img">
            <img width="30px" :src="item.avatar" alt="">
          </div>
          <div class="experts_item_desc">
            <div class="experts_item_name">{{item.doctor_name}}</div>
            <div class="experts_item_hos">{{item.hospital_title}}</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      experts_menu_num: '讲者',
      showInputNum: 0,
      name: '',
      "all": {
        "A": [
          {
            "id": "311",
            "doctor_name": "Andrea Necchi",
            "hospital_title": "意大利Foundation IRCCS国家癌症中心",
            "first_letter": "A",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-28/Compress/5db6b51d3ec7b.png",
            "picture_time": "1572255005",
            "tasks": [
              {
                "begin_time": "1702182900",
                "end_time": "1702183800",
                "identity": "1",
                "task": "Recent advances in the management of patients with BCG-unresponsive NMIBC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          }
        ],
        "B": [
          {
            "id": "607",
            "doctor_name": "卞晓洁",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "B",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-28/Compress/635ba415c4c97.jpg",
            "picture_time": "1666950165",
            "tasks": [
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "1",
                "task": "晚期尿路上皮癌一线治疗的选择和未来展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "276",
            "doctor_name": "毕建斌",
            "hospital_title": "中国医科大学附属第一医院",
            "first_letter": "B",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4c7698940.jpg",
            "picture_time": "1604996214",
            "tasks": [
              {
                "begin_time": "1702181100",
                "end_time": "1702182000",
                "identity": "2",
                "task": "Diagnostic and Therapeutic Implications of Sarcomatoid Histology in RCC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182000",
                "end_time": "1702182900",
                "identity": "2",
                "task": "EMBARK – the role of intensified ADT for biochemical recurrence",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182900",
                "end_time": "1702183800",
                "identity": "2",
                "task": "Recent advances in the management of patients with BCG-unresponsive NMIBC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "131",
            "doctor_name": "边家盛",
            "hospital_title": "山东省肿瘤医院",
            "first_letter": "B",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-11-05/Compress/5dc1363f4198c.jpg",
            "picture_time": "1572943423",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "2",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "2",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          }
        ],
        "C": [
          {
            "id": "443",
            "doctor_name": "曹达龙",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-19/Compress/60cd9b1f30bcd.jpeg",
            "picture_time": "1624087327",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "机器人和腹腔镜保肾手术关键技术的异同",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "保肾手术中的解剖及操作难点解析",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "823",
            "doctor_name": "褚健",
            "hospital_title": "上海市宝山区罗店医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562c693b30c5-50.png",
            "picture_time": "1700972179",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "MIBC保留膀胱：热潮中的冷思考",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "晚期尿路上皮癌一线治疗的选择和未来展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194900",
                "end_time": "1702195800",
                "identity": "2",
                "task": "ADC和免疫治疗在肌层浸润性膀胱癌围术期应用的探索与展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "716",
            "doctor_name": "曹晓明",
            "hospital_title": "山西医科大学第一医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465ff9850611-50.png",
            "picture_time": "1684406168",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "UTUC围手术期的治疗：经验与展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "TURBT的整块切除：利与弊",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "156",
            "doctor_name": "崔心刚",
            "hospital_title": "上海交通大学医学院附属新华医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-11-06/Compress/5dc2ca8a2fdfb.jpg",
            "picture_time": "1573046922",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "1",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "148",
            "doctor_name": "陈捷",
            "hospital_title": "江西省人民医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674b5725aa8-50.jpg",
            "picture_time": "1684491095",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "RP各手术入路的优劣探讨",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Learning from the Lutectomy trial – LuPSMA prior to radical prostatectomy",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "150",
            "doctor_name": "陈鹏",
            "hospital_title": "新疆医科大学附属肿瘤医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3a3a433db.jpg",
            "picture_time": "1604991546",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "Unmet needs in metastatic hormone sensitive prostate cancer",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "基因检测在前列腺癌中的最新发现及如何指导治疗",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "155",
            "doctor_name": "崔殿生",
            "hospital_title": "湖北省肿瘤医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa409ded13c.jpg",
            "picture_time": "1604993181",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "149",
            "doctor_name": "陈立军",
            "hospital_title": "中国人民解放军第五医学中心",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674b625b8a5-50.jpg",
            "picture_time": "1684491106",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "MIBC保留膀胱的现状及展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "机器人辅助膀胱癌根治术和尿流改道：Where do we stand and where do we go?",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "801",
            "doctor_name": "陈磊",
            "hospital_title": "上海中医药大学附属龙华医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-12-08/65729431dd2b2-50.jpg",
            "picture_time": "1702007857",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——正：可以免穿刺直接做根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——反：需穿刺明确病理再行根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "828",
            "doctor_name": "蔡一波",
            "hospital_title": "浙江省肿瘤医院",
            "first_letter": "C",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee679a9444-50.png",
            "picture_time": "1700718201",
            "tasks": [
              {
                "begin_time": "1702200000",
                "end_time": "1702200900",
                "identity": "1",
                "task": "前列腺个案管理模式的探讨与实践",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          }
        ],
        "D": [
          {
            "id": "826",
            "doctor_name": "丁滔",
            "hospital_title": "上海市奉贤区中心医院",
            "first_letter": "D",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-12-01/656989962e4b0-50.png",
            "picture_time": "1701415318",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "病例引导",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "复肿MDT病例讨论",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "80",
            "doctor_name": "Declan G. Murphy",
            "hospital_title": "澳大利亚Peter MacCallum肿瘤中心",
            "first_letter": "D",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-06/6456235c7ee0f-50.jpg",
            "picture_time": "1683366748",
            "tasks": [
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "1",
                "task": "Learning from the Lutectomy trial – LuPSMA prior to radical prostatectomy",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "123",
            "doctor_name": "戴波",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "D",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-26/Compress/60d6df72b467e.png",
            "picture_time": "1624694642",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702184100",
                "identity": "10",
                "task": "主会场开幕式主持",
                "meeting_model": null,
                "hall": "主会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "1",
                "task": "机器人辅助前列腺癌根治术中的几个操作细节分享",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "834",
            "doctor_name": "杜艳华",
            "hospital_title": "中国医学科学院肿瘤医院",
            "first_letter": "D",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-28/6565ac39c5e98-50.png",
            "picture_time": "1701162041",
            "tasks": [
              {
                "begin_time": "1702200600",
                "end_time": "1702201800",
                "identity": "3",
                "task": "“读屏时代”下医学科普的内容创作与传播策略",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          }
        ],
        "F": [
          {
            "id": "296",
            "doctor_name": "傅强",
            "hospital_title": "上海交通大学附属第六人民医院",
            "first_letter": "F",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa36c25b34b.png",
            "picture_time": "1604990658",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "MIBC保留膀胱：热潮中的冷思考",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "晚期尿路上皮癌一线治疗的选择和未来展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194900",
                "end_time": "1702195800",
                "identity": "2",
                "task": "ADC和免疫治疗在肌层浸润性膀胱癌围术期应用的探索与展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "735",
            "doctor_name": "傅强",
            "hospital_title": "山东省立医院",
            "first_letter": "F",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/6467337dd4e1f-50.jpg",
            "picture_time": "1684484989",
            "tasks": [
              {
                "begin_time": "1702181100",
                "end_time": "1702182000",
                "identity": "2",
                "task": "Diagnostic and Therapeutic Implications of Sarcomatoid Histology in RCC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182000",
                "end_time": "1702182900",
                "identity": "2",
                "task": "EMBARK – the role of intensified ADT for biochemical recurrence",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182900",
                "end_time": "1702183800",
                "identity": "2",
                "task": "Recent advances in the management of patients with BCG-unresponsive NMIBC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          }
        ],
        "G": [
          {
            "id": "622",
            "doctor_name": "顾晓锋",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-31/Compress/635f7a50d6146.jpg",
            "picture_time": "1667201616",
            "tasks": [
              {
                "begin_time": "1702198800",
                "end_time": "1702203300",
                "identity": "10",
                "task": "全场会议主持",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              },
              {
                "begin_time": "1702201200",
                "end_time": "1702202100",
                "identity": "1",
                "task": "多学科团队协作的前列腺癌根治术后尿失禁的管理",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              },
              {
                "begin_time": "1702202400",
                "end_time": "1702203300",
                "identity": "1",
                "task": "专委会总结+来年计划",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          },
          {
            "id": "162",
            "doctor_name": "苟欣",
            "hospital_title": "重庆医科大学附属第一医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3cf915c5c.jpg",
            "picture_time": "1604992249",
            "tasks": [
              {
                "begin_time": "1702173900",
                "end_time": "1702174800",
                "identity": "2",
                "task": "尿路上皮癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702174800",
                "end_time": "1702175700",
                "identity": "2",
                "task": "CACA前列腺癌指南解读与更新",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "504",
            "doctor_name": "谷江",
            "hospital_title": "贵州医科大学附属医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-02/Compress/60de85312f61c.jpeg",
            "picture_time": "1625195825",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "Unmet needs in metastatic hormone sensitive prostate cancer",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "基因检测在前列腺癌中的最新发现及如何指导治疗",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "444",
            "doctor_name": "顾成元",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-19/Compress/60cd9cdadb3ef.jpeg",
            "picture_time": "1624087770",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "818",
            "doctor_name": "耿和",
            "hospital_title": "上海市普陀区人民医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-12-08/65727cf1bdbba-50.jpg",
            "picture_time": "1702001905",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "从术中到术后，保肾手术并发症处理经验分享",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "复旦肿瘤肾癌研究盘点",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "120",
            "doctor_name": "郭剑明",
            "hospital_title": "复旦大学附属中山医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-11-09/Compress/636b650f69dfe.jpg",
            "picture_time": "1667982607",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "1",
                "task": "T1b期肾肿瘤预判保肾中山经验",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "320",
            "doctor_name": "甘华磊",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674b7a12e71-50.jpg",
            "picture_time": "1684491130",
            "tasks": [
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "1",
                "task": "前列腺癌病理诊断的进展及对目前治疗的影响",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "814",
            "doctor_name": "顾斌",
            "hospital_title": "上海市浦东新区人民医院",
            "first_letter": "G",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d0478aede-50.png",
            "picture_time": "1700974663",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "避免切缘阳性的技巧",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "提高术后残肾功能的要点",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          }
        ],
        "H": [
          {
            "id": "78",
            "doctor_name": "黄健",
            "hospital_title": "中山大学孙逸仙纪念医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64672e2f9b412-50.jpg",
            "picture_time": "1684483631",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "167",
            "doctor_name": "何立儒",
            "hospital_title": "中山大学肿瘤防治中心",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/646732fa02857-50.jpg",
            "picture_time": "1684484858",
            "tasks": [
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "1",
                "task": "根治性放疗——更新及展望",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "88",
            "doctor_name": "胡志全",
            "hospital_title": "华中科技大学同济医学院附属同济医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4d7f58098.jpg",
            "picture_time": "1604996479",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "2",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "2",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "719",
            "doctor_name": "黄玉华",
            "hospital_title": "苏州大学附属第一医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465fb39a6cfb-50.png",
            "picture_time": "1684405049",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——正方：体外尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——反方：体内尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "720",
            "doctor_name": "胡强",
            "hospital_title": "无锡市人民医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674b841a952-50.jpg",
            "picture_time": "1684491140",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "RP各手术入路的优劣探讨",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Learning from the Lutectomy trial – LuPSMA prior to radical prostatectomy",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "165",
            "doctor_name": "韩惟青",
            "hospital_title": "湖南省肿瘤医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad117cc529d.jpg",
            "picture_time": "1571623292",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "T1b期肾肿瘤预判保肾中山经验",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "AR技术精准定位完全内生型肾肿瘤",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "164",
            "doctor_name": "韩邦旻",
            "hospital_title": "上海交通大学医学院附属第一人民医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-29/647454e9c7348-50.png",
            "picture_time": "1685345513",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "1",
                "task": "寡转移前列腺癌局部治疗的意义及文献解读",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "166",
            "doctor_name": "何朝宏",
            "hospital_title": "河南省肿瘤医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3df8cd596.jpg",
            "picture_time": "1604992504",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "2",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "2",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "110",
            "doctor_name": "何志嵩",
            "hospital_title": "北京大学第一医院",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbfbb0af654.jpg",
            "picture_time": "1541143472",
            "tasks": [
              {
                "begin_time": "1702170000",
                "end_time": "1702170900",
                "identity": "1",
                "task": "基于尿液的液体活检在尿路上皮癌诊断中的应用",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "373",
            "doctor_name": "何厚胜",
            "hospital_title": "加拿大多伦多大学玛格丽特公主癌症中心",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-12-04/Compress/5fca54028589b.jpg",
            "picture_time": "1607095298",
            "tasks": [
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "1",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "312",
            "doctor_name": "黄浩杰",
            "hospital_title": "美国梅奥诊所",
            "first_letter": "H",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-28/Compress/5db6b5ab3420d.png",
            "picture_time": "1572255147",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "1",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          }
        ],
        "J": [
          {
            "id": "177",
            "doctor_name": "金百冶",
            "hospital_title": "浙江大学医学院附属第一医院",
            "first_letter": "J",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad1069b7b14.jpg",
            "picture_time": "1571623017",
            "tasks": [
              {
                "begin_time": "1702173900",
                "end_time": "1702174800",
                "identity": "2",
                "task": "尿路上皮癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702174800",
                "end_time": "1702175700",
                "identity": "2",
                "task": "CACA前列腺癌指南解读与更新",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "87",
            "doctor_name": "姜昊文",
            "hospital_title": "复旦大学附属华山医院",
            "first_letter": "J",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3df988334.jpg",
            "picture_time": "1604992505",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "1",
                "task": "前列腺癌根治术——从患者特点到个体化的手术方案",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "174",
            "doctor_name": "贾瑞鹏",
            "hospital_title": "南京市第一医院",
            "first_letter": "J",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad10adc30ce.jpg",
            "picture_time": "1571623085",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "RP各手术入路的优劣探讨",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Learning from the Lutectomy trial – LuPSMA prior to radical prostatectomy",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "413",
            "doctor_name": "姜帅",
            "hospital_title": "复旦大学附属中山医院",
            "first_letter": "J",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-12-04/Compress/5fca12e353a06.png",
            "picture_time": "1607078627",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "1",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——反：需穿刺明确病理再行根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          }
        ],
        "L": [
          {
            "id": "598",
            "doctor_name": "林天歆",
            "hospital_title": "中山大学孙逸仙纪念医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64672e467577b-50.jpg",
            "picture_time": "1684483654",
            "tasks": [
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "1",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "507",
            "doctor_name": "李恭会",
            "hospital_title": "浙江大学医学院附属邵逸夫医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-11-03/Compress/6182776847e77.jpg",
            "picture_time": "1635940200",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "2",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "2",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "103",
            "doctor_name": "刘南",
            "hospital_title": "重庆大学附属肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-06/Compress/5fa4f559bd0c4.jpg",
            "picture_time": "1604646233",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "1",
                "task": "避免切缘阳性的技巧",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "190",
            "doctor_name": "李鑫",
            "hospital_title": "包头市肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3f9a39065.jpg",
            "picture_time": "1604992922",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "前列腺癌根治术——从患者特点到个体化的手术方案",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "根治性放疗——更新及展望",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "740",
            "doctor_name": "吕忠",
            "hospital_title": "常州市武进人民医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465fffae3124-50.jpg",
            "picture_time": "1684406266",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "前列腺癌根治术——从患者特点到个体化的手术方案",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "根治性放疗——更新及展望",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "485",
            "doctor_name": "刘承",
            "hospital_title": "上海交通大学附属第一人民医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674bb50e4ae-50.jpg",
            "picture_time": "1684491189",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "186",
            "doctor_name": "李军",
            "hospital_title": "甘肃省肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad1523e309d.jpg",
            "picture_time": "1571624227",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "T1b期肾肿瘤预判保肾中山经验",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "AR技术精准定位完全内生型肾肿瘤",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "193",
            "doctor_name": "李长福",
            "hospital_title": "哈尔滨医科大学附属肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3fe82993b.jpg",
            "picture_time": "1604993000",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "Unmet needs in metastatic hormone sensitive prostate cancer",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "基因检测在前列腺癌中的最新发现及如何指导治疗",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "194",
            "doctor_name": "李长岭",
            "hospital_title": "中国医学科学院肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4dcff02be.jpg",
            "picture_time": "1604996559",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              },
              {
                "begin_time": "1702168200",
                "end_time": "1702169100",
                "identity": "2",
                "task": "前列腺癌临床研究——推动学科建设的东方快车",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702169100",
                "end_time": "1702170000",
                "identity": "2",
                "task": "从ESMO2023进展谈PARPi与NHA联合治疗方案的一些问题",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702170000",
                "end_time": "1702170900",
                "identity": "2",
                "task": "基于尿液的液体活检在尿路上皮癌诊断中的应用",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "195",
            "doctor_name": "廖洪",
            "hospital_title": "四川省肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad1461def63.jpg",
            "picture_time": "1571624033",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "2",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "2",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "1",
                "task": "保留性功能的膀胱癌根治术：技巧和展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "315",
            "doctor_name": "李永红",
            "hospital_title": "中山大学肿瘤防治中心",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-11-05/Compress/5dc16d519d6bc.jpg",
            "picture_time": "1572957521",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "1",
                "task": "RP各手术入路的优劣探讨",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "128",
            "doctor_name": "刘卓炜",
            "hospital_title": "中山大学肿瘤防治中心",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-16/Compress/5fb24d97d9444.jpg",
            "picture_time": "1605520791",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "2",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "2",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "1",
                "task": "机器人辅助膀胱癌根治术和尿流改道：Where do we stand and where do we go?",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "188",
            "doctor_name": "李宁忱",
            "hospital_title": "北京大学首钢医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64672e613ab2b-50.jpg",
            "picture_time": "1684483681",
            "tasks": [
              {
                "begin_time": "1702171500",
                "end_time": "1702172400",
                "identity": "2",
                "task": "前列腺癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702172400",
                "end_time": "1702173300",
                "identity": "2",
                "task": "肾癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "1",
                "task": "UTUC围手术期的治疗：经验与展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "835",
            "doctor_name": "刘冬",
            "hospital_title": "上海长征医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee6a27eb5c-50.png",
            "picture_time": "1700718242",
            "tasks": [
              {
                "begin_time": "1702202100",
                "end_time": "1702203300",
                "identity": "1",
                "task": "1例孤立肾多发肿瘤患者围手术期护理体会",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          },
          {
            "id": "192",
            "doctor_name": "李毅宁",
            "hospital_title": "福建医科大学附属第二医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674b9e782e6-50.jpg",
            "picture_time": "1684491166",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "MIBC保留膀胱的现状及展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "机器人辅助膀胱癌根治术和尿流改道：Where do we stand and where do we go?",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "816",
            "doctor_name": "刘荣福",
            "hospital_title": "同济大学附属杨浦医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d08748ffd-50.jpg",
            "picture_time": "1700974727",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——保肾手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——根治手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "387",
            "doctor_name": "林国文",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-07/Compress/60e571a19a355.jpg",
            "picture_time": "1625649569",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "1",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——正：可以免穿刺直接做根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "353",
            "doctor_name": "李宏召",
            "hospital_title": "中国人民解放军总医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-06/Compress/5fa4f532884f3.jpg",
            "picture_time": "1604646194",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "1",
                "task": "膀胱癌根治术尿流改道的选择——反方：体内尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "815",
            "doctor_name": "廖国强",
            "hospital_title": "上海健康医学院附属周浦医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562c81fd6fb6-50.jpg",
            "picture_time": "1700972575",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——保肾手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——根治手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "831",
            "doctor_name": "林倩雯",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee68cca828-50.png",
            "picture_time": "1700718220",
            "tasks": [
              {
                "begin_time": "1702201200",
                "end_time": "1702202100",
                "identity": "3",
                "task": "多学科团队协作的前列腺癌根治术后尿失禁的管理",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          },
          {
            "id": "594",
            "doctor_name": "刘冰",
            "hospital_title": "海军军医大学第三附属医院（上海东方肝胆外科医院）",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-28/Compress/635ba474eefc5.png",
            "picture_time": "1666950260",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "1",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——保肾手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "196",
            "doctor_name": "刘畅",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "L",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad143620b74.jpg",
            "picture_time": "1571623990",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          }
        ],
        "M": [
          {
            "id": "631",
            "doctor_name": "马利民",
            "hospital_title": "南通大学附属医院",
            "first_letter": "M",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-31/Compress/635fc00797783.jpg",
            "picture_time": "1667219463",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "寡转移前列腺癌局部治疗的意义及文献解读",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "机器人辅助前列腺癌根治术中的几个操作细节分享",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "202",
            "doctor_name": "马学军",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "M",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad17f9d6709.jpg",
            "picture_time": "1571624953",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "203",
            "doctor_name": "蒙清贵",
            "hospital_title": "广西医科大学附属肿瘤医院",
            "first_letter": "M",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674bc14d49d-50.jpg",
            "picture_time": "1684491201",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "保留性功能的膀胱癌根治术：技巧和展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Optimal Preoperative systemic therapy for muscle invasive bladder cancer",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "556",
            "doctor_name": "马春光",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "M",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-12-05/Compress/61ac9dca81d0e.png",
            "picture_time": "1638702538",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——正方：体外尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——反方：体内尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          }
        ],
        "P": [
          {
            "id": "508",
            "doctor_name": "Philippe E. Spiess",
            "hospital_title": "美国Moffitt肿瘤中心泌尿外科 南佛罗里达州大学医学院",
            "first_letter": "P",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-11-03/Compress/618270dec6c98.png",
            "picture_time": "1635938526",
            "tasks": [
              {
                "begin_time": "1702181100",
                "end_time": "1702182000",
                "identity": "1",
                "task": "Diagnostic and Therapeutic Implications of Sarcomatoid Histology in RCC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "802",
            "doctor_name": "彭煜",
            "hospital_title": "上海中医药大学附属岳阳中西医结合医院",
            "first_letter": "P",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-28/6565af635c12f-50.jpg",
            "picture_time": "1701162851",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "如何最大化保留前列腺周围结构和功能",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "前列腺癌病理诊断的进展及对目前治疗的影响",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          }
        ],
        "Q": [
          {
            "id": "97",
            "doctor_name": "齐琳",
            "hospital_title": "中南大学湘雅医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbe820e566f.jpg",
            "picture_time": "1541138464",
            "tasks": [
              {
                "begin_time": "1702168200",
                "end_time": "1702169100",
                "identity": "2",
                "task": "前列腺癌临床研究——推动学科建设的东方快车",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702169100",
                "end_time": "1702170000",
                "identity": "2",
                "task": "从ESMO2023进展谈PARPi与NHA联合治疗方案的一些问题",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702170000",
                "end_time": "1702170900",
                "identity": "2",
                "task": "基于尿液的液体活检在尿路上皮癌诊断中的应用",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "209",
            "doctor_name": "邱建宏",
            "hospital_title": "中国人民解放军白求恩国际和平医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-22/646aee1bc7caa-50.png",
            "picture_time": "1684729371",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "保留性功能的膀胱癌根治术：技巧和展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Optimal Preoperative systemic therapy for muscle invasive bladder cancer",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "722",
            "doctor_name": "秦扬",
            "hospital_title": "云南省肿瘤医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465face641f3-50.png",
            "picture_time": "1684404942",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "Unmet needs in metastatic hormone sensitive prostate cancer",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "基因检测在前列腺癌中的最新发现及如何指导治疗",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "270",
            "doctor_name": "秦晓健",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa368a48b73.jpg",
            "picture_time": "1604990602",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "寡转移前列腺癌局部治疗的意义及文献解读",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "机器人辅助前列腺癌根治术中的几个操作细节分享",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "438",
            "doctor_name": "瞿元元",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-19/Compress/60cd9bd191b50.jpeg",
            "picture_time": "1624087505",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "从术中到术后，保肾手术并发症处理经验分享",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "复旦肿瘤肾癌研究盘点",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "207",
            "doctor_name": "钱伟庆",
            "hospital_title": "复旦大学附属华东医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674be26e920-50.jpg",
            "picture_time": "1684491234",
            "tasks": [
              {
                "begin_time": "1702181100",
                "end_time": "1702182000",
                "identity": "2",
                "task": "Diagnostic and Therapeutic Implications of Sarcomatoid Histology in RCC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182000",
                "end_time": "1702182900",
                "identity": "2",
                "task": "EMBARK – the role of intensified ADT for biochemical recurrence",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702182900",
                "end_time": "1702183800",
                "identity": "2",
                "task": "Recent advances in the management of patients with BCG-unresponsive NMIBC",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "102",
            "doctor_name": "齐隽",
            "hospital_title": "上海交通大学医学院附属新华医院",
            "first_letter": "Q",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-06-07/648051a8ec5ad-50.png",
            "picture_time": "1686131112",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——正：可以免穿刺直接做根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——反：需穿刺明确病理再行根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          }
        ],
        "S": [
          {
            "id": "429",
            "doctor_name": "宋少莉",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/646732a6d6719-50.jpg",
            "picture_time": "1684484774",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "病例引导",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "复肿MDT病例讨论",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "824",
            "doctor_name": "宋旭",
            "hospital_title": "上海中医药大学附属第七人民医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-29/65668f9fbf04c-50.png",
            "picture_time": "1701220255",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "MIBC保留膀胱：热潮中的冷思考",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "晚期尿路上皮癌一线治疗的选择和未来展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194900",
                "end_time": "1702195800",
                "identity": "2",
                "task": "ADC和免疫治疗在肌层浸润性膀胱癌围术期应用的探索与展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "211",
            "doctor_name": "施国伟",
            "hospital_title": "复旦大学附属第五人民医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674bf5eab7e-50.jpg",
            "picture_time": "1684491253",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "MIBC保留膀胱：热潮中的冷思考",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "晚期尿路上皮癌一线治疗的选择和未来展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194900",
                "end_time": "1702195800",
                "identity": "2",
                "task": "ADC和免疫治疗在肌层浸润性膀胱癌围术期应用的探索与展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "113",
            "doctor_name": "孙忠全",
            "hospital_title": "复旦大学附属华东医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4b8c681c2.jpg",
            "picture_time": "1604995980",
            "tasks": [
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "1",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "384",
            "doctor_name": "Shahrokh F. Shariat",
            "hospital_title": "奥地利维也纳医科大学维也纳总医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-12-04/Compress/5fca55911b407.jpg",
            "picture_time": "1607095697",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "1",
                "task": "Unmet needs in metastatic hormone sensitive prostate cancer",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "1",
                "task": "Optimal Preoperative systemic therapy for muscle invasive bladder cancer",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "210",
            "doctor_name": "施国海",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad177cca176.jpg",
            "picture_time": "1571624828",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "1",
                "task": "从术中到术后，保肾手术并发症处理经验分享",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "213",
            "doctor_name": "史本康",
            "hospital_title": "山东大学齐鲁医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-30/Compress/5c009d24d6163.jpg",
            "picture_time": "1543544100",
            "tasks": [
              {
                "begin_time": "1702173900",
                "end_time": "1702174800",
                "identity": "1",
                "task": "尿路上皮癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "811",
            "doctor_name": "宿恒川",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d09b41017-50.png",
            "picture_time": "1700974747",
            "tasks": [
              {
                "begin_time": "1702197300",
                "end_time": "1702198200",
                "identity": "11",
                "task": "MDT讨论",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "300",
            "doctor_name": "Stephen J. Freedland",
            "hospital_title": "美国Cedars-Sinai医学中心",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-28/Compress/5db65cc015499.jpg",
            "picture_time": "1572232384",
            "tasks": [
              {
                "begin_time": "1702182000",
                "end_time": "1702182900",
                "identity": "1",
                "task": "EMBARK – the role of intensified ADT for biochemical recurrence",
                "meeting_model": "中西对话，转化前沿【（二）国际视角——见微知著】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "797",
            "doctor_name": "邵远",
            "hospital_title": "上海交通大学医学院附属瑞金医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562c6de3ea71-50.jpg",
            "picture_time": "1700972254",
            "tasks": [
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "1",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——根治手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "117",
            "doctor_name": "沈益君",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "S",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-12/Compress/5be8f94ae118b.jpg",
            "picture_time": "1541994826",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702194900",
                "end_time": "1702195800",
                "identity": "1",
                "task": "ADC和免疫治疗在肌层浸润性膀胱癌围术期应用的探索与展望",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          }
        ],
        "T": [
          {
            "id": "219",
            "doctor_name": "涂新华",
            "hospital_title": "江西省肿瘤医院",
            "first_letter": "T",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad2349148f5.jpg",
            "picture_time": "1571627849",
            "tasks": [
              {
                "begin_time": "1702178700",
                "end_time": "1702179600",
                "identity": "2",
                "task": "转录重编辑在前列腺癌治疗抗性中的作用",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702179600",
                "end_time": "1702180500",
                "identity": "2",
                "task": "The transcriptional and functional landscape of m6A epitranscriptome in prostate cancer",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          }
        ],
        "W": [
          {
            "id": "274",
            "doctor_name": "翁国斌",
            "hospital_title": "宁波市鄞州人民医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-18/Compress/5da98eb419abe.jpg",
            "picture_time": "1571393204",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "2",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "2",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "227",
            "doctor_name": "王小林",
            "hospital_title": "南通大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa41bceca9c.jpg",
            "picture_time": "1604993468",
            "tasks": [
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "1",
                "task": "保肾手术中的解剖及操作难点解析",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "799",
            "doctor_name": "王强",
            "hospital_title": "贵州医科大学附属医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562c6ea2e674-50.png",
            "picture_time": "1700972266",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "前列腺癌根治术——从患者特点到个体化的手术方案",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "根治性放疗——更新及展望",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "715",
            "doctor_name": "王科",
            "hospital_title": "青岛大学附属医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674c710087d-50.jpg",
            "picture_time": "1684491376",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "222",
            "doctor_name": "王东文",
            "hospital_title": "中国医学科学院肿瘤医院深圳医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-09/Compress/60e7c9615374f.jpg",
            "picture_time": "1625803105",
            "tasks": [
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "1",
                "task": "TURBT的整块切除：利与弊",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "759",
            "doctor_name": "王东",
            "hospital_title": "内蒙古自治区肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674c13843d4-50.jpg",
            "picture_time": "1684491283",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "T1b期肾肿瘤预判保肾中山经验",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "AR技术精准定位完全内生型肾肿瘤",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "233",
            "doctor_name": "吴登龙",
            "hospital_title": "同济大学附属同济医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674c908d3d8-50.jpg",
            "picture_time": "1684491408",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "2",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "2",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "234",
            "doctor_name": "吴芃",
            "hospital_title": "南方医科大学南方医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4ef47070f.jpg",
            "picture_time": "1604996852",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "318",
            "doctor_name": "王红霞",
            "hospital_title": "上海交通大学附属第一人民医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-18/Compress/5da9843d183ec.jpg",
            "picture_time": "1571390525",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "836",
            "doctor_name": "王李君",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-29/6566a78f1d665-50.png",
            "picture_time": "1701226383",
            "tasks": [
              {
                "begin_time": "1702202100",
                "end_time": "1702203300",
                "identity": "3",
                "task": "1例孤立肾多发肿瘤患者围手术期护理体会",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          },
          {
            "id": "820",
            "doctor_name": "王乾",
            "hospital_title": "上海交通大学医学院附属新华医院崇明分院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d15621032-50.png",
            "picture_time": "1700974934",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "从术中到术后，保肾手术并发症处理经验分享",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "复旦肿瘤肾癌研究盘点",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "809",
            "doctor_name": "王珊珊",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d16245de9-50.png",
            "picture_time": "1700974946",
            "tasks": [
              {
                "begin_time": "1702197300",
                "end_time": "1702198200",
                "identity": "11",
                "task": "MDT讨论",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "386",
            "doctor_name": "王奇峰",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-26/Compress/60d6e3a8462e7.png",
            "picture_time": "1624695720",
            "tasks": [
              {
                "begin_time": "1702197300",
                "end_time": "1702198200",
                "identity": "11",
                "task": "MDT讨论",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "712",
            "doctor_name": "万方宁",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465fa59db858-50.png",
            "picture_time": "1684404825",
            "tasks": [
              {
                "begin_time": "1702195200",
                "end_time": "1702196100",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——正：可以免穿刺直接做根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "2",
                "task": "前列腺诊断，免穿刺进行治疗的时机是否达到？——反：需穿刺明确病理再行根治术",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "830",
            "doctor_name": "王琳",
            "hospital_title": "南通市肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee77c01851-50.png",
            "picture_time": "1700718459",
            "tasks": [
              {
                "begin_time": "1702200000",
                "end_time": "1702200900",
                "identity": "3",
                "task": "前列腺个案管理模式的探讨与实践",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          },
          {
            "id": "330",
            "doctor_name": "王弘恺",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-25/Compress/60d5b1ee564a4.jpeg",
            "picture_time": "1624617454",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "如何最大化保留前列腺周围结构和功能",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "前列腺癌病理诊断的进展及对目前治疗的影响",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "392",
            "doctor_name": "王翔",
            "hospital_title": "上海交通大学附属第一人民医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-12-04/Compress/5fca560d27a8f.jpg",
            "picture_time": "1607095821",
            "tasks": [
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "1",
                "task": "提高术后残肾功能的要点",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "94",
            "doctor_name": "魏强",
            "hospital_title": "四川大学华西医院",
            "first_letter": "W",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa492f12342.jpg",
            "picture_time": "1604995375",
            "tasks": [
              {
                "begin_time": "1702169100",
                "end_time": "1702170000",
                "identity": "1",
                "task": "从ESMO2023进展谈PARPi与NHA联合治疗方案的一些问题",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              }
            ]
          }
        ],
        "X": [
          {
            "id": "600",
            "doctor_name": "徐斌",
            "hospital_title": "上海交通大学附属第九人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64673320c8c97-50.jpg",
            "picture_time": "1684484896",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "避免切缘阳性的技巧",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "提高术后残肾功能的要点",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "305",
            "doctor_name": "许青",
            "hospital_title": "同济大学附属第十人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674cba79cf1-50.jpg",
            "picture_time": "1684491450",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "病例引导",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "2",
                "task": "复肿MDT病例讨论",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "790",
            "doctor_name": "徐东亮",
            "hospital_title": "上海中医药大学附属曙光医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d17749f07-50.png",
            "picture_time": "1700974967",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "机器人和腹腔镜保肾手术关键技术的异同",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "保肾手术中的解剖及操作难点解析",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "242",
            "doctor_name": "徐万海",
            "hospital_title": "哈尔滨医科大学第四附属医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad12ec394a4.jpg",
            "picture_time": "1571623660",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "1",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "239",
            "doctor_name": "肖峻",
            "hospital_title": "中国科学技术大学附属第一医院（安徽省立医院）",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa47fd947d5.png",
            "picture_time": "1604995069",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "1",
                "task": "机器人和腹腔镜保肾手术关键技术的异同",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "812",
            "doctor_name": "徐耀庭",
            "hospital_title": "同济大学附属上海市第四人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-12-08/65726ce0759f6-50.jpg",
            "picture_time": "1701997792",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "多发肾肿瘤的极限保肾手术",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "肾癌分子标志物和分子分型：路漫漫其修远兮",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "500",
            "doctor_name": "谢宇",
            "hospital_title": "湖南省肿瘤医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-06-25/Compress/60d5b427decd5.png",
            "picture_time": "1624618023",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "UTUC围手术期的治疗：经验与展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "TURBT的整块切除：利与弊",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "245",
            "doctor_name": "薛波新",
            "hospital_title": "苏州大学附属第二医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3ca020f55.jpg",
            "picture_time": "1604992160",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "UTUC围手术期的治疗：经验与展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "TURBT的整块切除：利与弊",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "240",
            "doctor_name": "徐仁芳",
            "hospital_title": "常州第一人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674cd24027d-50.jpg",
            "picture_time": "1684491474",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "UTUC围手术期的治疗：经验与展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "TURBT的整块切除：利与弊",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "292",
            "doctor_name": "肖克峰",
            "hospital_title": "深圳市人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-06/Compress/60e3ca87e49be.jpg",
            "picture_time": "1625541255",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "保留性功能的膀胱癌根治术：技巧和展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Optimal Preoperative systemic therapy for muscle invasive bladder cancer",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "246",
            "doctor_name": "薛学义",
            "hospital_title": " 福建医科大学附属第一医院 ",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3e150523b.jpg",
            "picture_time": "1604992533",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "MIBC保留膀胱的现状及展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "机器人辅助膀胱癌根治术和尿流改道：Where do we stand and where do we go?",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "833",
            "doctor_name": "徐江美",
            "hospital_title": "同济大学附属第十人民医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee6d7b0c6e-50.png",
            "picture_time": "1700718295",
            "tasks": [
              {
                "begin_time": "1702200600",
                "end_time": "1702201800",
                "identity": "1",
                "task": "“读屏时代”下医学科普的内容创作与传播策略",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          },
          {
            "id": "112",
            "doctor_name": "邢念增",
            "hospital_title": "中国医学科学院肿瘤医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbe3db82d99.jpg",
            "picture_time": "1541137371",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "98",
            "doctor_name": "邢金春",
            "hospital_title": "厦门大学附属第一医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-07/Compress/60e579153a789.jpg",
            "picture_time": "1625651477",
            "tasks": [
              {
                "begin_time": "1702171500",
                "end_time": "1702172400",
                "identity": "1",
                "task": "前列腺癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "82",
            "doctor_name": "薛蔚",
            "hospital_title": "上海交通大学医学院附属仁济医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674cabc3328-50.jpg",
            "picture_time": "1684491435",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              },
              {
                "begin_time": "1702171500",
                "end_time": "1702172400",
                "identity": "2",
                "task": "前列腺癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702172400",
                "end_time": "1702173300",
                "identity": "2",
                "task": "肾癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "81",
            "doctor_name": "徐丹枫",
            "hospital_title": "上海交通大学医学院附属瑞金医院",
            "first_letter": "X",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa380f4ed80.png",
            "picture_time": "1604990991",
            "tasks": [
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "1",
                "task": "AR技术精准定位完全内生型肾肿瘤",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          }
        ],
        "Y": [
          {
            "id": "68",
            "doctor_name": "叶定伟",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbe43831f45.jpg",
            "picture_time": "1541137464",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702184100",
                "identity": "7",
                "task": "第十三届上海泌尿肿瘤学术大会暨中国抗癌协会男性生殖系统肿瘤专委会（CACA-GO）年会",
                "meeting_model": null,
                "hall": "主会场"
              },
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              },
              {
                "begin_time": "1702168200",
                "end_time": "1702169100",
                "identity": "1",
                "task": "前列腺癌临床研究——推动学科建设的东方快车",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "427",
            "doctor_name": "余志贤",
            "hospital_title": "温州医科大学附属第一医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674ceae9873-50.jpg",
            "picture_time": "1684491498",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "前列腺癌根治术——从患者特点到个体化的手术方案",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "根治性放疗——更新及展望",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（一）根治技巧，釜底抽薪】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "268",
            "doctor_name": "俞洪元",
            "hospital_title": "浙江省台州医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674cdfec5b5-50.jpg",
            "picture_time": "1684491487",
            "tasks": [
              {
                "begin_time": "1702186800",
                "end_time": "1702187700",
                "identity": "2",
                "task": "RP各手术入路的优劣探讨",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702187700",
                "end_time": "1702188600",
                "identity": "2",
                "task": "Learning from the Lutectomy trial – LuPSMA prior to radical prostatectomy",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "247",
            "doctor_name": "杨勇",
            "hospital_title": "北京大学肿瘤医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-21/Compress/5dad0f6401ca6.jpg",
            "picture_time": "1571622756",
            "tasks": [
              {
                "begin_time": "1702173900",
                "end_time": "1702174800",
                "identity": "2",
                "task": "尿路上皮癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702174800",
                "end_time": "1702175700",
                "identity": "2",
                "task": "CACA前列腺癌指南解读与更新",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "394",
            "doctor_name": "杨国胜",
            "hospital_title": "同济大学附属东方医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-02/Compress/60ded74e59fe2.png",
            "picture_time": "1625216846",
            "tasks": [
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "2",
                "task": "T1b期肾肿瘤预判保肾中山经验",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "2",
                "task": "AR技术精准定位完全内生型肾肿瘤",
                "meeting_model": "“肾”机妙算——运筹帷幄",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "728",
            "doctor_name": "姚伟强",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/646603651fa1e-50.jpg",
            "picture_time": "1684407141",
            "tasks": [
              {
                "begin_time": "1702197300",
                "end_time": "1702198200",
                "identity": "11",
                "task": "MDT讨论",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "119",
            "doctor_name": "姚旭东",
            "hospital_title": "同济大学附属第十人民医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-07/Compress/60e574665d86e.jpg",
            "picture_time": "1625650278",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "1",
                "task": "膀胱癌根治术尿流改道的选择——正方：体外尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "101",
            "doctor_name": "姚欣",
            "hospital_title": "天津医科大学肿瘤医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4fd569c8b.jpg",
            "picture_time": "1604997077",
            "tasks": [
              {
                "begin_time": "1702168200",
                "end_time": "1702169100",
                "identity": "2",
                "task": "前列腺癌临床研究——推动学科建设的东方快车",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702169100",
                "end_time": "1702170000",
                "identity": "2",
                "task": "从ESMO2023进展谈PARPi与NHA联合治疗方案的一些问题",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702170000",
                "end_time": "1702170900",
                "identity": "2",
                "task": "基于尿液的液体活检在尿路上皮癌诊断中的应用",
                "meeting_model": "高峰观点，开创新篇",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "829",
            "doctor_name": "袁静",
            "hospital_title": "同济大学附属第十人民医院",
            "first_letter": "Y",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee706c4713-50.png",
            "picture_time": "1700718342",
            "tasks": [
              {
                "begin_time": "1702198800",
                "end_time": "1702199700",
                "identity": "3",
                "task": "前列腺癌疼痛特点和护理管理",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          }
        ],
        "Z": [
          {
            "id": "758",
            "doctor_name": "周广臣",
            "hospital_title": "苏北人民医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-22/646ae55c4489d-50.png",
            "picture_time": "1684727132",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "寡转移前列腺癌局部治疗的意义及文献解读",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "机器人辅助前列腺癌根治术中的几个操作细节分享",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "250",
            "doctor_name": "张爱莉",
            "hospital_title": "河北医科大学第四医院（省肿瘤医院）",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2019-10-18/Compress/5da993f665b59.jpg",
            "picture_time": "1571394550",
            "tasks": [
              {
                "begin_time": "1702176300",
                "end_time": "1702177200",
                "identity": "2",
                "task": "分子影像导航泌尿肿瘤精准诊疗",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              },
              {
                "begin_time": "1702177200",
                "end_time": "1702178100",
                "identity": "2",
                "task": "替雷利珠单抗联合顺铂与吉西他滨新辅助治疗cT2-T4aN0M0膀胱尿路上皮癌患者的多中心临床研究",
                "meeting_model": "中西对话，转化前沿【（一）中华论据——引领浪潮】",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "346",
            "doctor_name": "张凯",
            "hospital_title": "北京和睦家医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-06/Compress/5fa4f687997f0.jpg",
            "picture_time": "1604646535",
            "tasks": [
              {
                "begin_time": "1702188900",
                "end_time": "1702189800",
                "identity": "2",
                "task": "机器人和腹腔镜保肾手术关键技术的异同",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702189800",
                "end_time": "1702190700",
                "identity": "2",
                "task": "保肾手术中的解剖及操作难点解析",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "519",
            "doctor_name": "周家权",
            "hospital_title": "海南省人民医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64674d18b658a-50.jpg",
            "picture_time": "1684491544",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——正方：体外尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "膀胱癌根治术尿流改道的选择——反方：体内尿流改道",
                "meeting_model": "（二）刀“胱”剑影——专题辩论",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "77",
            "doctor_name": "周利群",
            "hospital_title": "北京大学第一医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbcc69efeb8.jpg",
            "picture_time": "1541131369",
            "tasks": [
              {
                "begin_time": "1702171500",
                "end_time": "1702172400",
                "identity": "2",
                "task": "前列腺癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702172400",
                "end_time": "1702173300",
                "identity": "2",
                "task": "肾癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "395",
            "doctor_name": "张旭（院士）",
            "hospital_title": "中国人民解放军总医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-07-07/Compress/60e56af3cfb34.jpg",
            "picture_time": "1625647859",
            "tasks": [
              {
                "begin_time": "1702166400",
                "end_time": "1702168200",
                "identity": "4",
                "task": "领导嘉宾致辞",
                "meeting_model": "开幕式",
                "hall": "主会场"
              }
            ]
          },
          {
            "id": "271",
            "doctor_name": "张海梁",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-11-04/Compress/6364ddc196d83.png",
            "picture_time": "1667554753",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197000",
                "identity": "1",
                "task": "复旦肿瘤肾癌研究盘点",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "263",
            "doctor_name": "邹青",
            "hospital_title": "江苏省肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa4e97c0b86.jpg",
            "picture_time": "1604996759",
            "tasks": [
              {
                "begin_time": "1702172400",
                "end_time": "1702173300",
                "identity": "1",
                "task": "肾癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "261",
            "doctor_name": "朱绍兴",
            "hospital_title": "福建医科大学协和医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64672e870e46e-50.jpg",
            "picture_time": "1684483719",
            "tasks": [
              {
                "begin_time": "1702174800",
                "end_time": "1702175700",
                "identity": "1",
                "task": "CACA前列腺癌指南解读与更新",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197600",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——肾脏肿瘤分会场",
                "meeting_model": null,
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "605",
            "doctor_name": "周良平",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-28/Compress/635ba4205d668.png",
            "picture_time": "1666950176",
            "tasks": [
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "11",
                "task": "复肿MDT团队",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "143",
            "doctor_name": "曾浩",
            "hospital_title": "四川大学华西医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-10/Compress/5faa3d798366d.jpg",
            "picture_time": "1604992377",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702198200",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——前列腺肿瘤分会场",
                "meeting_model": null,
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702185600",
                "end_time": "1702186500",
                "identity": "1",
                "task": "基因检测在前列腺癌中的最新发现及如何指导治疗",
                "meeting_model": "前列腺癌诊疗新进展",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "136",
            "doctor_name": "朱刚",
            "hospital_title": "北京和睦家医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-02/Compress/5bdbe4ae44a82.jpg",
            "picture_time": "1541137582",
            "tasks": [
              {
                "begin_time": "1702173900",
                "end_time": "1702174800",
                "identity": "2",
                "task": "尿路上皮癌最新进展2023年度回顾",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702174800",
                "end_time": "1702175700",
                "identity": "2",
                "task": "CACA前列腺癌指南解读与更新",
                "meeting_model": "浦江论剑，博古通今",
                "hall": "主会场"
              },
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "8",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702184700",
                "end_time": "1702185600",
                "identity": "1",
                "task": "MIBC保留膀胱的现状及展望",
                "meeting_model": "（一）发扬“胱”大——专题讲演",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "808",
            "doctor_name": "周冰妮",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d1afab2b3-50.png",
            "picture_time": "1700975023",
            "tasks": [
              {
                "begin_time": "1702197300",
                "end_time": "1702198200",
                "identity": "11",
                "task": "MDT讨论",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（四）焦点穿刺，各抒己见】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "817",
            "doctor_name": "张青川",
            "hospital_title": "上海中医药大学附属普陀医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d18ce3c24-50.png",
            "picture_time": "1700974988",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——保肾手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "肾癌侵犯肾窦和肾盂，保肾 or 根治？——根治手术",
                "meeting_model": "“肾”意盎然——热点再探",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "612",
            "doctor_name": "郑霞",
            "hospital_title": "中山大学肿瘤防治中心",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2022-10-31/Compress/635f79bc5d5ff.jpg",
            "picture_time": "1667201468",
            "tasks": [
              {
                "begin_time": "1702199100",
                "end_time": "1702200300",
                "identity": "1",
                "task": "ERAS模式下肾癌患者围手术期优化护理管理",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          },
          {
            "id": "126",
            "doctor_name": "朱一平",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2018-11-12/Compress/5be8f9903ce9f.jpg",
            "picture_time": "1541994896",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702196100",
                "end_time": "1702197300",
                "identity": "1",
                "task": "病例引导",
                "meeting_model": "（四）出类“膀”通——MDT对话",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "832",
            "doctor_name": "张姬",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562d1816c791-50.png",
            "picture_time": "1700974977",
            "tasks": [
              {
                "begin_time": "1702198800",
                "end_time": "1702204200",
                "identity": "10",
                "task": "全场会议主持",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              },
              {
                "begin_time": "1702199100",
                "end_time": "1702200300",
                "identity": "3",
                "task": "ERAS模式下肾癌患者围手术期优化护理管理",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              },
              {
                "begin_time": "1702203600",
                "end_time": "1702204200",
                "identity": "1",
                "task": "会议总结",
                "meeting_model": null,
                "hall": "肾癌整合护理分会场"
              }
            ]
          },
          {
            "id": "343",
            "doctor_name": "张朋",
            "hospital_title": "四川大学华西医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2020-11-06/Compress/5fa4f2e035b3f.jpg",
            "picture_time": "1604645600",
            "tasks": [
              {
                "begin_time": "1702184400",
                "end_time": "1702197900",
                "identity": "9",
                "task": "第十三届上海泌尿肿瘤学术大会——膀胱肿瘤分会场",
                "meeting_model": null,
                "hall": "膀胱肿瘤分会场"
              },
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "1",
                "task": "MIBC保留膀胱：热潮中的冷思考",
                "meeting_model": "（三）集思“胱”益——格致论道",
                "hall": "膀胱肿瘤分会场"
              }
            ]
          },
          {
            "id": "805",
            "doctor_name": "朱汝健",
            "hospital_title": "复旦大学附属浦东医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-26/6562c6fa39f74-50.png",
            "picture_time": "1700972282",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "2",
                "task": "如何最大化保留前列腺周围结构和功能",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702194000",
                "end_time": "1702194900",
                "identity": "2",
                "task": "前列腺癌病理诊断的进展及对目前治疗的影响",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "510",
            "doctor_name": "朱煜",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2021-11-03/Compress/6182738d17f30.png",
            "picture_time": "1635939213",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "避免切缘阳性的技巧",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "提高术后残肾功能的要点",
                "meeting_model": "各显“肾”通——手术演示",
                "hall": "肾脏肿瘤分会场"
              }
            ]
          },
          {
            "id": "73",
            "doctor_name": "朱耀",
            "hospital_title": "复旦大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-19/64672e7913110-50.jpg",
            "picture_time": "1684483705",
            "tasks": [
              {
                "begin_time": "1702193100",
                "end_time": "1702194000",
                "identity": "1",
                "task": "如何最大化保留前列腺周围结构和功能",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（三）早诊早治，巨细无遗】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          },
          {
            "id": "827",
            "doctor_name": "赵云",
            "hospital_title": "江苏省肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-11-23/655ee64e90c61-50.png",
            "picture_time": "1700718158",
            "tasks": [
              {
                "begin_time": "1702198800",
                "end_time": "1702199700",
                "identity": "1",
                "task": "前列腺癌疼痛特点和护理管理",
                "meeting_model": null,
                "hall": "前列腺癌整合护理分会场"
              }
            ]
          },
          {
            "id": "718",
            "doctor_name": "张庆云",
            "hospital_title": "广西医科大学附属肿瘤医院",
            "first_letter": "Z",
            "avatar": "http://msgos.urocancer.org/Uploads/Picture/2023-05-18/6465ff4c74539-50.png",
            "picture_time": "1684406092",
            "tasks": [
              {
                "begin_time": "1702191000",
                "end_time": "1702191900",
                "identity": "2",
                "task": "寡转移前列腺癌局部治疗的意义及文献解读",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              },
              {
                "begin_time": "1702191900",
                "end_time": "1702192800",
                "identity": "2",
                "task": "机器人辅助前列腺癌根治术中的几个操作细节分享",
                "meeting_model": "论“列”是非——局部治疗焦点探讨【（二）高危处理，同心协力】",
                "hall": "前列腺肿瘤分会场"
              }
            ]
          }
        ]
      },
    }
  },
  methods: {
    showInput(num) {
      this.showInputNum = num
      if (!this.showInputNum) {
        this.name = ''
      }
    },
    clearInput() {
      this.name = ''
    },
    experts_menu_Fn(num) {
      this.experts_menu_num = num
    }
  }
}
</script>

<style lang="less" scoped>
.expertsList {
  width: 100%;
  max-width: 750px;
  margin: auto;
  background-color: #f2f8ff;
}
.experts_base {
  position: fixed;
  z-index: 999;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
  background-color: #f2f8ff;
}
.bgcfff {
  background-color: #fff;
  padding-bottom: 12px;
}

.experts_list {
  width: 100%;
  overflow: auto;
}
.hidden {
  height: 100vh;
  overflow: hidden;
}
.experts_search {
  position: relative;
  text-align: center;
  height: 36px;
  line-height: 36px;
}
.experts_input_box {
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 2;
  top: 0;
  padding: 12px;
  .experts_icon {
    display: none;
    position: absolute;
  }
  .icon_left {
    left: 25px;
  }
  .icon_right {
    right: 65px;
  }
  input {
    flex: 1;
    height: 36px;
    outline: 0;
    background: transparent;
    border: 0px solid #f3f3f3;
    border-radius: 36px;
    padding: 0 30px 0 30px;
    text-align: center;
  }
  .experts_input_close {
    margin-left: 12px;
  }
}

.experts_input_no {
  position: absolute;
  z-index: 1;
  left: 12px;
  width: calc(100% - 24px);
  border-radius: 36px;
  right: 0;
  background: #ffffff;
}

.experts_input_show {
  .experts_icon {
    display: inline-block;
  }
  input {
    background: #f3f3f3;
    border: 1px solid #f3f3f3;
    text-align: left;
  }
}

.experts_search_base {
  position: fixed;
  width: 100%;
  min-height: 100vh;
  top: 0px;
  background-color: #fff;
  z-index: 0;
}
.experts_menu {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0px;
}
.experts_menu_item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #009afc;
  position: relative;
  transition: all 0.3s;
}
.experts_menu_check {
  transition: all 0.3s;
  font-weight: 700;
}
.experts_menu_Line {
  position: absolute;
  bottom: -4px;
  width: 2em;
  height: 2px;
  background-color: #009afc;
  animation: line 0.5s;
}
@keyframes line {
  from {
    width: 0;
  }
  to {
    width: 2em;
  }
}
.experts_list {
  padding: 87px 12px 0 12px;
}
.experts_item_title {
  background-color: #e4f0ff;
  padding-left: 12px;
}
.experts_item_data {
  display: flex;
  height: 74px;
  background-color: #fff;
  padding: 0 12px;
  align-items: center;
}
.experts_item_img {
  display: flex;
  height: 100%;
  align-items: center;
  width: 56px;
  height: 56px;
  overflow: hidden;
  border-radius: 56px;
  margin-right: 12px;
  position: relative;
  img {
    width: 56px;
    position: absolute;
    top: 0px;
  }
}
.experts_item_desc {
  display: flex;
  flex: 1;
  height: 74px;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e6ecef;
}
</style> 